module.exports = __webpack_public_path__ + "static/media/cost-card-icon.65fef2af.svg";